import Presentation from "./presentation";

const CreatorCardList = ( { list } ) => {
	return (
		<Presentation list = { list } />
	);
};

export default CreatorCardList;